<template>
  <div v-if="inputData && (inputData.admStatus ===1 || inputData.admStatus===0 || inputData.admStatus===3 )" class="signUp" style="padding: 0 1em; text-align: left;">
    

    <div v-if="2 === saveFg" >
      <br />
      <font style="font-size:x-large; color:#253d24;">恭喜!您已經完成預填資料</font><br>
      <font style="font-size:x-large; color:#253d24;">填寫資料如欲修改，請於審核前完成調整</font>
      <br />
      <br />
    </div>
    
    <div style="padding: 0.2em;"
      v-else>     
      <el-steps :space="200" :active="active" finish-status="success" simple>
        <el-step :title="item.title"
          v-for="item in tabsData"
          :key="item.pageId"
          :icon="item.icon"></el-step>
      </el-steps>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick"
        v-if="(null != inputData)">



        <el-tab-pane name="P0" key="0" :disabled="tabsData[0].disabled" >
            <span slot="label"><i :class="tabsData[0].icon"></i>{{tabsData[0].title}}</span>
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;">

              <tr>
                <td style="padding: 1em;">
                            <div>
            <p >
              <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
              :src="sysDoc" 
              v-for="i in numPages"
              :key="i"
              :page="i"
              ></pdf>
            </p>

          </div>               
                  
                  <b>上述告知事項本人已詳細閱讀，並同意資料使用</b>：
                                       <el-select placeholder="請選擇是否同意資料使用" style="width: 8em;"
                        v-model="acceptPrivacy"
                        @change="onPrivacyChange"
                 >
                        <el-option
                          v-for="item in setData"
                          :key="'T1'+item.id"
                          :label="item.name"
                          :value="item.id"/>
                  </el-select>
                </td>
              </tr>

             
            </table>
            <br />
            <div class="ncut-base-form-button" style="text-align: center;">
              
              <el-button type="primary" @click="nextPage()">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>            
  
            </div>
        </el-tab-pane>




        <el-tab-pane name="P1" key="1" :disabled="tabsData[1].disabled" >
          <span slot="label"><i :class="tabsData[1].icon"></i>{{tabsData[1].title}}</span>
          <div class="template-div">
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all" v-if="!rwdFlag">
              <tbody >
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">身分證號</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.id}}
                  </td>
                   <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">姓名</td>
                  <td class="ncut-base-form-ipt">            
                    {{inputData.title}}
                  </td>
                </tr>
                                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">手機號碼</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.phone}}
                  </td>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">出生年月日</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.bir}}
                  </td>
                </tr>
               
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">
                    戶籍地址
                  </td>
                  <td class="ncut-base-form-ipt" colspan='3'>            
                    {{user.houseAddress}}
                  </td>
                </tr>
                                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">
                     通訊地址
                  </td>
                  <td class="ncut-base-form-ipt" colspan='3'>            
                    {{user.curAddress}}
                  </td>
                </tr>
                
                <tr>
                  <td colspan="4">
                    <p v-html="applicationMsg[0].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                       v-if="applicationMsg!=null"></p>
                  </td>
                </tr>
              </tbody>
            </table>
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" rules="all" v-if ="rwdFlag">
              <tbody >
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">身分證號</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.id}}
                  </td>
                </tr>
                  <tr>
                   <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">姓名</td>
                  <td class="ncut-base-form-ipt">            
                    {{inputData.title}}
                  </td>
                </tr>
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">手機號碼</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.phone}}
                  </td>
                </tr>
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">出生年月日</td>
                  <td class="ncut-base-form-ipt">            
                    {{user.bir}}
                  </td>
                </tr>
               
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">
                    戶籍地址
                  </td>
                  <td class="ncut-base-form-ipt" colspan='3'>            
                    {{user.houseAddress}}
                  </td>
                </tr>
                <tr>
                  <td class="ncut-edit-form-text ncut-require-title" style="padding: 0.2em 1em;">
                     通訊地址
                  </td>
                  <td class="ncut-base-form-ipt" colspan='3'>            
                    {{user.curAddress}}
                  </td>
                </tr>  
                <tr>
                  <td colspan="2">
                    <p v-html="applicationMsg[0].contText" style="font-size:10px;"
                       v-if="applicationMsg!=null"></p>
                  </td>
                </tr>
              </tbody>
            </table>
            
            <br />
            <div class="ncut-base-form-button" style="text-align: center;">
              <el-button type="primary" plain @click="prevPage()" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              <el-button type="primary" @click="nextPage()">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="P2" key="2" :disabled="tabsData[2].disabled" >
            <span slot="label"><i :class="tabsData[2].icon"></i>{{tabsData[2].title}}</span>
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" v-if ="!rwdFlag" >
              <tr >
                <td style="padding: 1em;" >
                  <b>1.學雜費減免需求</b>：
                 <el-radio-group v-model="inputData.body.type2">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <span v-if="inputData.body.type2 ==1"> <br/>【本項僅調查意願需求，提醒務必於新生學雜費減免申請期間至學雜費減免系統線上申請。】<a href="http://nmsd.ncut.edu.tw/Relief/Web/reduIndex.html" target="_blank">請點我：學雜費減免系統</a>
                    </span>
                </td>
              </tr>
              <tr>
                <td style="padding: 1em;">
                  <b>2.就學貸款需求　</b>：
                   <!--<el-select placeholder="請選擇是否有就學貸款需求" style="width: 8em;"
                        v-model="inputData.body.type3">
                        <el-option
                          v-for="item in setData"
                          :key="'T2'+item.id"
                          :label="item.name"
                          :value="item.id"/>
                  </el-select>-->
                   <el-radio-group v-model="inputData.body.type3">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <span v-if="inputData.body.type3 ==1"> <br/>【本項僅調查意願需求，提醒務必至臺灣銀行辦理對保，並於就學貸款申請期間至就學貸款系統線上申請。】<a href="https://nmsd.ncut.edu.tw/Loan/Web/index.html" target="_blank">請點我：就學貸款系統</a>
                    </span>
                </td>
              </tr>

                <tr v-if="inputData.exportSmt==1">
                  <td style="padding: 1em;">
                    <b>3.入住校內宿舍需求　</b>：
                    <!--<el-select placeholder="請選擇是否有入住校內宿舍需求" style="width: 8em;"
                          v-model="inputData.body.type5">
                          <el-option
                            v-for="item in setData"
                            :key="'T5'+item.id"
                            :label="item.name"
                            :value="item.id"/>
                    </el-select>-->
                    <el-radio-group v-model="inputData.body.type5">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>

                      <span v-if="inputData.body.type5==1">

                        <td class="ncut-base-form-ipt" >                                 
                          <el-select 
                            placeholder="請選擇宿舍申請身分" style="width: 180px;"
                            v-model="inputData.body.dormKind"
                            :clearable="true"
                            @change="e => {if(!e) disableAfter(active)}"
                            >
                            <el-option
                              v-for="item in dormTypes"
                              :key="'T6'+item.optionNo"
                              :label="item.codeName"
                              :value="item.optionNo">
                            </el-option>
                            <el-option key="0" label="請選擇身分" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                        </td>             
                      </span>
                <br/>
               <span>★申請資格：本學年度進修部入學新生 <span style="color:red">（轉學考、碩士在職專班及產學訓一年級除外）</span>，如為不能申請之學制同學，需求處請協助填<span style="color:red">「否」</span>，謝謝。</span><br>
                <span v-if="inputData.body.type5==1"> ★患有法定傳染性疾病或其他重病短期內無法痊癒而有隔離必要或特殊治療者或其他特殊個案不宜團體住宿者，均不得申請住宿，以維護住宿生之健康與安全。</span><br/>
                <span v-if="inputData.body.type5==1 && (inputData.body.dormKind!=0 && inputData.body.dormKind!=1)" >★相關證明檔
                  <li>檔名 .jpg</li>
                  <li>每個檔案大小不得超過4MB。</li>
                      <el-upload style="padding: 1em 2em 1.5em;"
                                  ref="uploadV2"
                                  class="upload-demo"
                                  drag
                                  :limit="1"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".jpg"
                                  :name="'f' + user.id + '_7'"
                                  :on-success="handleFileUploadSuccess"
                                  :on-remove="handleChangeF7"
                                  :before-upload="onBeforeUploadF7">
                                  <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳檔案</span></i>
                      </el-upload>


                      <div>

                                        <ul style="clear:both" v-if="(inputData.info7!=null) && (inputData.info7.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg7List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>


                       <el-upload style="padding: 1em 2em 1.5em;"
                        ref="uploadV2"
                        class="upload-demo"
                        drag
                        :limit="1"
                        action="./WebApi/Tools/UploadV2"
                        accept=".jpg"
                        :name="'f' + user.id + '_8'"
                        :on-success="handleFileUploadSuccess"
                        :on-remove="handleChangeF8"
                        :before-upload="onBeforeUploadF8">
                        <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳檔案</span></i>
                     </el-upload>
                      <div>

                                        <ul style="clear:both" v-if="(inputData.info8!=null) && (inputData.info8.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg8List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>



                      <div>  
                        說明：<br>
                        ★以下為本校宿舍入住規定之優先順序，會依以下順序安排床位，<br>
                            <span>1.持有身心障礙證明或特殊教育學生鑑定證明書身份之學生，<span style="color:red">請檢附有效期限內政府開立之證明文件。</span></span><br>
                            <span>2.低收入戶身份之學生，<span style="color:red">請檢附有效期限內政府開立之證明文件。</span></span><br>
                            <span>3.中低收入戶身份之學生，<span style="color:red">請檢附有效期限內政府開立之證明文件。</span></span><br>
                            <span>4.家庭突遭不可抗拒之天然災害並持有社政單位証明者或事實足證有特殊需要者，<span style="color:red">請檢附有效期限內政府開立之證明文件。</span></span><br>
                            <span>5.原住民身份之學生，<span style="color:red">請檢附三個月內之戶籍謄本。</span></span><br>
                            <span>6.離島生（持設藉滿乙年以上之全戶證明）身份之學生，<span style="color:red">請檢附三個月內之戶籍謄本。</span></span><br>
                      </div>

                  </span>


                </td>


              </tr>
              
            </table>

            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;" v-if ="rwdFlag" >
              <tr >
                <td style="padding: 1em;" >
                  <b>1.學雜費減免需求</b>：
                 <el-radio-group v-model="inputData.body.type2">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <span v-if="inputData.body.type2 ==1"> <br/>【本項僅調查意願需求，提醒務必於新生<br/>學雜費減免申請期間至學雜費減免系統線<br/>上申請。】<a href="http://nmsd.ncut.edu.tw/Relief/Web/reduIndex.html" target="_blank">請點我：學雜費減免系統</a>
                    </span>
                </td>
              </tr>
              <tr>
                <td style="padding: 1em;">
                  <b>2.就學貸款需求　</b>：
                   <!--<el-select placeholder="請選擇是否有就學貸款需求" style="width: 8em;"
                        v-model="inputData.body.type3">
                        <el-option
                          v-for="item in setData"
                          :key="'T2'+item.id"
                          :label="item.name"
                          :value="item.id"/>
                  </el-select>-->
                   <el-radio-group v-model="inputData.body.type3">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>
                  <span v-if="inputData.body.type3 ==1"> <br/>【本項僅調查意願需求，提醒務必至臺灣<br/>銀行辦理對保，並於就學貸款申請期間至<br/>就學貸款系統線上申請。】<br/><a href="https://nmsd.ncut.edu.tw/Loan/Web/index.html" target="_blank">請點我：就學貸款系統</a>
                    </span>
                </td>
              </tr>

                <tr v-if="inputData.exportSmt==1">
                  <td style="padding: 1em;">
                    <b>3.入住校內宿舍需求　</b>：
                    <!--<el-select placeholder="請選擇是否有入住校內宿舍需求" style="width: 8em;"
                          v-model="inputData.body.type5">
                          <el-option
                            v-for="item in setData"
                            :key="'T5'+item.id"
                            :label="item.name"
                            :value="item.id"/>
                    </el-select>-->
                    <el-radio-group v-model="inputData.body.type5">
                      <el-radio :label="0">否</el-radio>
                      <el-radio :label="1">是</el-radio>
                  </el-radio-group>

                      <span v-if="inputData.body.type5==1">

                        <td class="ncut-base-form-ipt" >                                 
                          <el-select 
                            placeholder="請選擇宿舍申請身分" style="width: 180px;"
                            v-model="inputData.body.dormKind"
                            :clearable="true"
                            @change="e => {if(!e) disableAfter(active)}"
                            >
                            <el-option
                              v-for="item in dormTypes"
                              :key="'T6'+item.optionNo"
                              :label="item.codeName"
                              :value="item.optionNo">
                            </el-option>
                            <el-option key="0" label="請選擇身分" :value="0" :disabled="true"></el-option>
                          </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                        </td>             
                      </span>
                <br/>
               <span>★申請資格：本學年度進修部入學新生<br/> <span style="color:red">（轉學考、碩士在職專班及產學訓一年<br/>級除外）</span>，如為不能申請之學制同學，<br/>需求處請協助填<span style="color:red">「否」</span>，謝謝。</span><br>
                <span v-if="inputData.body.type5==1"> ★患有法定傳染性疾病或其他重病短期<br/>內無法痊癒而有隔離必要或特殊治療者<br/>或其他特殊個案不宜團體住宿者，均不<br/>得申請住宿，以維護住宿生之健康與安全。</span><br/>
                <span v-if="inputData.body.type5==1 && (inputData.body.dormKind!=0 && inputData.body.dormKind!=1)" >★相關證明檔
                  <li>檔名 .jpg</li>
                  <li>每個檔案大小不得超過4MB。</li>
                      <el-upload style="padding: 1em 2em 1.5em;"
                                  ref="uploadV2"
                                  class="upload-demo"
                                  drag
                                  :limit="1"
                                  action="./WebApi/Tools/UploadV2"
                                  accept=".jpg"
                                  :name="'f' + user.id + '_7'"
                                  :on-success="handleFileUploadSuccess"
                                  :on-remove="handleChangeF7"
                                  :before-upload="onBeforeUploadF7">
                                  <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳檔案</span></i>
                      </el-upload>


                      <div>

                                        <ul style="clear:both" v-if="(inputData.info7!=null) && (inputData.info7.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg7List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>


                       <el-upload style="padding: 1em 2em 1.5em;"
                        ref="uploadV2"
                        class="upload-demo"
                        drag
                        :limit="1"
                        action="./WebApi/Tools/UploadV2"
                        accept=".jpg"
                        :name="'f' + user.id + '_8'"
                        :on-success="handleFileUploadSuccess"
                        :on-remove="handleChangeF8"
                        :before-upload="onBeforeUploadF8">
                        <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳檔案</span></i>
                     </el-upload>
                      <div>

                                        <ul style="clear:both" v-if="(inputData.info8!=null) && (inputData.info8.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg8List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>
                      <div>  
                        說明：<br>
                        ★以下為本校宿舍入住規定之優先順序<br/>，會依以下順序安排床位，<br>
                            <span>1.持有身心障礙證明或特殊教育學生鑑<br/>定證明書身份之學生，<span style="color:red">請檢附有效期限<br/>內政府開立之證明文件。</span></span><br>
                            <span>2.低收入戶身份之學生，<span style="color:red">請檢附有效期<br/>限內政府開立之證明文件。</span></span><br>
                            <span>3.中低收入戶身份之學生，<span style="color:red">請檢附有效<br/>期限內政府開立之證明文件。</span></span><br>
                            <span>4.家庭突遭不可抗拒之天然災害並持有<br/>社政單位証明者或事實足證有特殊需要<br/>者，<span style="color:red">請檢附有效期限內政府開立之證明<br/>文件。</span></span><br>
                            <span>5.原住民身份之學生，<span style="color:red">請檢附三個月內<br/>之戶籍謄本。</span></span><br>
                            <span>6.離島生（持設藉滿乙年以上之全戶證<br/>明）身份之學生，<span style="color:red">請檢附三個月內之戶<br/>籍謄本。</span></span><br>
                      </div>
                  </span>
                </td>
              </tr>
              
            </table>



            <br />
            <div class="ncut-base-form-button" style="text-align: center;">
              <el-button type="primary" plain @click="prevPage()" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              
              <el-button type="primary" @click="nextPage()">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              
              
            </div>
        </el-tab-pane>


        <el-tab-pane name="P3" key="3" :disabled="tabsData[3].disabled" >
            <el-alert type="warning" :closable="false" v-if="isFemale">※女性免填此頁，請按下一步</el-alert>
            <span slot="label"><i :class="tabsData[3].icon"></i>{{tabsData[3].title}}</span>
            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;"  v-if ="!rwdFlag">
              <tr>
                <td style="padding: 1em;">
                  <b>1.兵役狀況</b>：
                  <el-select 
                    placeholder="請選擇兵役狀況" style="width: 180px;"
                    v-model="inputData.body.serviceStatus"
                    :disabled="isFemale"
                    :clearable="true"
                    @change="e => {if(!e) disableAfter(active)}"
                    >
                    <el-option
                      v-for="item in serviceTypes"
                      :key="'T3'+item.optionNo"
                      :label="item.codeName"
                      :value="item.optionNo">
                    </el-option>
                    <el-option key="0" label="請選擇" :value="0" :disabled="true"></el-option>
                  </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                  <br>


                  
                  <span v-if="inputData.body.serviceStatus==1 || inputData.body.serviceStatus==2 || inputData.body.serviceStatus==5">
                  <tr>
                    <br>
                    <span class="ncut-ipnut-form-text">戶籍縣市：</span>&nbsp;
                    <el-select placeholder="請選擇縣市" style="width: 8em;"
                        v-model="inputData.body.schCity"
                        @change="districtItem1=null; inputData.body.schDistrict=null; getResDistrictItem();"
                        :disabled="cityItem==null">
                        <el-option
                          v-for="item in cityItem"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="請選擇" :value="0" :disabled="true"></el-option>
                      </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                      <span class="ncut-ipnut-form-text">鄉鎮市區：</span>&nbsp;
                       <!--<el-select v-model="inputData.body.schDistrict" placeholder="請選擇鄉鎮"
                        style="width: 8em;"
                        :disabled="districtItem1==null">
                        <el-option
                          v-for="item in districtItem1"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>-->
                      <el-select v-model="inputData.body.schDistrict" placeholder="請選擇鄉鎮"
                        style="width: 8em;"
                        :disabled="districtItem1==null">
                        <el-option
                          v-for="item in districtItem1"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>
                      &nbsp;&nbsp;&nbsp;&nbsp;
              </tr>

                <tr>
                <span v-if="inputData.body.serviceStatus==2 || inputData.body.serviceStatus==5 "><br>軍階/替代役
                    <el-select placeholder="請選擇軍階" style="width: 8em;"
                        v-model="inputData.body.type1" :disabled="isFemale">
                        <el-option
                          v-for="item in joinType"
                          :key="'T4'+item.optionNo"
                          :label="item.codeName"
                          :value="item.optionNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>

                  </span>
                 
                 </tr>
              <br>
              <br>
              <span>★身分證正面檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_2'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF2"
                              :before-upload="onBeforeUploadF2">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳身分證正面JPG檔</span></i>
                    </el-upload>

                </span>
               <div>

                  <ul style="clear:both" v-if="(inputData.info2!=null) && (inputData.info2.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'PH'+index">
                      <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                      &nbsp;&nbsp;<i class="el-icon-delete"
                                    @click="setDelFlag(f)"
                                     v-show="false"></i>
                    </li>
                  </ul>

              </div>
                <span >★身分證反面檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_3'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF3"
                              :before-upload="onBeforeUploadF3">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">傳身分證反面JPG檔</span></i>
                    </el-upload>

                  </span>
                 <div>

                      <ul style="clear:both" v-if="(inputData.info3!=null) && (inputData.info3.length > 0)" class="response">
                        <li class="sel-file" v-for="(f,index) in filterImg3List" :key="index" :index="'0'+index" :name="'PH'+index">
                          <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                            <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                            <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                          </a>
                          &nbsp;&nbsp;<i class="el-icon-delete"
                                        @click="setDelFlag(f)"
                                        v-show="false"></i>
                        </li>
                      </ul>

                  </div>


                  <span v-if="inputData.body.serviceStatus==2">★退伍令
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_4'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF4"
                              :before-upload="onBeforeUploadF4">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳退伍令JPG檔</span></i>
                    </el-upload>


                    <div>

                  <ul style="clear:both" v-if="(inputData.info4!=null) && (inputData.info4.length > 0)" class="response">
                                      <li class="sel-file" v-for="(f,index) in filterImg4List" :key="index" :index="'0'+index" :name="'PH'+index">
                                        <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                        </a>
                                        &nbsp;&nbsp;<i class="el-icon-delete"
                                                      @click="setDelFlag(f)"
                                                      v-show="false"></i>
                                      </li>
                                    </ul>

                  </div>



                  </span>
              <br>


            </span>


                  <span v-if="inputData.body.serviceStatus==3">★免役證明檔
             <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_5'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF5"
                              :before-upload="onBeforeUploadF5">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳免役證明JPG檔</span></i>
                    </el-upload>

                      <div>

                                        <ul style="clear:both" v-if="(inputData.info5!=null) && (inputData.info5.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg5List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>

                  </span>
                  <span v-if="inputData.body.serviceStatus==4">★服役證明檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                                ref="uploadV2"
                                class="upload-demo"
                                drag
                                :limit="1"
                                action="./WebApi/Tools/UploadV2"
                                accept=".jpg"
                                :name="'f' + user.id + '_6'"
                                :on-success="handleFileUploadSuccess"
                                :on-remove="handleChangeF6"
                                :before-upload="onBeforeUploadF6">
                                <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳服役證明JPG檔</span></i>
                    </el-upload>


                      <div>

                                        <ul style="clear:both" v-if="(inputData.info6!=null) && (inputData.info6.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg6List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>

                  </span>
                      <p v-html="applicationMsg[1].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                v-if="applicationMsg!=null"></p>


                                        <span v-if="inputData.body.serviceStatus==1"><b>2.在學期間是否有意願參加【專案服役】?</b>：
                                    <span style="color:red">(僅限進修部四技94年次以後出生役男申請(不含進修部二專、二技、產業四技專班及碩士在職專班))</span><br>
                            <el-radio-group v-model="inputData.body.war">
                                <el-radio :label="2">請選擇</el-radio>
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>

                            <span v-if="inputData.body.war==1">
                              <br><span style="color:red">欲申請專案服役者，請注意修業期限及課程學分是否符合產業實務實習、考照或就業資格條件。</span><br>
                              預定入伍時間：
                                  <el-radio-group v-model="inputData.body.lv">
                                      <el-radio :label="2">大二上</el-radio>
                                      <el-radio :label="3">大二下</el-radio>
                                      <el-radio :label="4">大三上</el-radio>
                                      <el-radio :label="5">大三下</el-radio>
                                      <el-radio :label="6">大四上</el-radio>
                                  </el-radio-group>
                            </span>




                          </span>
                </td>

              </tr>
             

            </table>

            <table style="background-color: #F0FFF8;border: gray;font-size: 1rem; width:100%;"  v-if ="rwdFlag">
              <tr>
                <td style="padding: 1em;">
                  <b>1.兵役狀況</b>：
                  <el-select 
                    placeholder="請選擇兵役狀況" style="width: 180px;"
                    v-model="inputData.body.serviceStatus"
                    :disabled="isFemale"
                    :clearable="true"
                    @change="e => {if(!e) disableAfter(active)}"
                    >
                    <el-option
                      v-for="item in serviceTypes"
                      :key="'T3'+item.optionNo"
                      :label="item.codeName"
                      :value="item.optionNo">
                    </el-option>
                    <el-option key="0" label="請選擇" :value="0" :disabled="true"></el-option>
                  </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                  <br>


                  
                  <span v-if="inputData.body.serviceStatus==1 || inputData.body.serviceStatus==2 || inputData.body.serviceStatus==5">
                  <tr>
                    <br>
                    <span class="ncut-ipnut-form-text">戶籍縣市：</span>&nbsp;
                    <el-select placeholder="請選擇縣市" style="width: 8em;"
                        v-model="inputData.body.schCity"
                        @change="districtItem1=null; inputData.body.schDistrict=null; getResDistrictItem();"
                        :disabled="cityItem==null">
                        <el-option
                          v-for="item in cityItem"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="請選擇" :value="0" :disabled="true"></el-option>
                      </el-select>&nbsp;&nbsp;&nbsp;&nbsp;
                      <br/><span class="ncut-ipnut-form-text">鄉鎮市區：</span>&nbsp;
                       <!--<el-select v-model="inputData.body.schDistrict" placeholder="請選擇鄉鎮"
                        style="width: 8em;"
                        :disabled="districtItem1==null">
                        <el-option
                          v-for="item in districtItem1"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>-->
                      <el-select v-model="inputData.body.schDistrict" placeholder="請選擇鄉鎮"
                        style="width: 8em;"
                        :disabled="districtItem1==null">
                        <el-option
                          v-for="item in districtItem1"
                          :key="item.codeNo"
                          :label="item.zipName"
                          :value="item.codeNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>
                      &nbsp;&nbsp;&nbsp;&nbsp;
              </tr>

                <tr>
                <span v-if="inputData.body.serviceStatus==2 || inputData.body.serviceStatus==5"><br>軍階/替代役
                    <el-select placeholder="請選擇軍階" style="width: 8em;"
                        v-model="inputData.body.type1" :disabled="isFemale">
                        <el-option
                          v-for="item in joinType"
                          :key="'T4'+item.optionNo"
                          :label="item.codeName"
                          :value="item.optionNo">
                        </el-option>
                        <el-option key="0" label="無" :value="0" :disabled="true"></el-option>
                      </el-select>

                  </span>
                 
                 </tr>
              <br>
              <br>
              <span>★身分證正面檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_2'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF2"
                              :before-upload="onBeforeUploadF2">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳身分證正面JPG檔</span></i>
                    </el-upload>

                </span>
               <div>

                  <ul style="clear:both" v-if="(inputData.info2!=null) && (inputData.info2.length > 0)" class="response">
                    <li class="sel-file" v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'PH'+index">
                      <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                        <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                        <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                      </a>
                      &nbsp;&nbsp;<i class="el-icon-delete"
                                    @click="setDelFlag(f)"
                                     v-show="false"></i>
                    </li>
                  </ul>

              </div>
                <span >★身分證反面檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_3'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF3"
                              :before-upload="onBeforeUploadF3">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">傳身分證反面JPG檔</span></i>
                    </el-upload>

                  </span>
                 <div>

                      <ul style="clear:both" v-if="(inputData.info3!=null) && (inputData.info3.length > 0)" class="response">
                        <li class="sel-file" v-for="(f,index) in filterImg3List" :key="index" :index="'0'+index" :name="'PH'+index">
                          <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                            <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                            <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                          </a>
                          &nbsp;&nbsp;<i class="el-icon-delete"
                                        @click="setDelFlag(f)"
                                        v-show="false"></i>
                        </li>
                      </ul>

                  </div>


                  <span v-if="inputData.body.serviceStatus==2">★退伍令
                    <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_4'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF4"
                              :before-upload="onBeforeUploadF4">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳退伍令JPG檔</span></i>
                    </el-upload>


                    <div>

                  <ul style="clear:both" v-if="(inputData.info4!=null) && (inputData.info4.length > 0)" class="response">
                                      <li class="sel-file" v-for="(f,index) in filterImg4List" :key="index" :index="'0'+index" :name="'PH'+index">
                                        <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                          <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                          <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                        </a>
                                        &nbsp;&nbsp;<i class="el-icon-delete"
                                                      @click="setDelFlag(f)"
                                                      v-show="false"></i>
                                      </li>
                                    </ul>

                  </div>



                  </span>
              <br>


            </span>


                  <span v-if="inputData.body.serviceStatus==3">★免役證明檔
             <el-upload style="padding: 1em 2em 1.5em;"
                              ref="uploadV2"
                              class="upload-demo"
                              drag
                              :limit="1"
                              action="./WebApi/Tools/UploadV2"
                              accept=".jpg"
                              :name="'f' + user.id + '_5'"
                              :on-success="handleFileUploadSuccess"
                              :on-remove="handleChangeF5"
                              :before-upload="onBeforeUploadF5">
                              <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳免役證明JPG檔</span></i>
                    </el-upload>

                      <div>

                                        <ul style="clear:both" v-if="(inputData.info5!=null) && (inputData.info5.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg5List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>

                  </span>
                  <span v-if="inputData.body.serviceStatus==4">★服役證明檔
                    <el-upload style="padding: 1em 2em 1.5em;"
                                ref="uploadV2"
                                class="upload-demo"
                                drag
                                :limit="1"
                                action="./WebApi/Tools/UploadV2"
                                accept=".jpg"
                                :name="'f' + user.id + '_6'"
                                :on-success="handleFileUploadSuccess"
                                :on-remove="handleChangeF6"
                                :before-upload="onBeforeUploadF6">
                                <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳服役證明JPG檔</span></i>
                    </el-upload>


                      <div>

                                        <ul style="clear:both" v-if="(inputData.info6!=null) && (inputData.info6.length > 0)" class="response">
                                          <li class="sel-file" v-for="(f,index) in filterImg6List" :key="index" :index="'0'+index" :name="'PH'+index">
                                            <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                            </a>
                                            &nbsp;&nbsp;<i class="el-icon-delete"
                                                          @click="setDelFlag(f)"
                                                          v-show="false"></i>
                                          </li>
                                        </ul>

                      </div>

                  </span>
                      <p v-html="applicationMsg[1].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                v-if="applicationMsg!=null"></p>


                                        <span v-if="inputData.body.serviceStatus==1"><b>2.在學期間是否有意願參加【專案服役】?</b>：<br/>
                                    <span style="color:red">(僅限進修部四技94年次以後出生役男申請(不含進修部二專、二技、產業四技專班及碩士在職專班))</span><br>
                            <el-radio-group v-model="inputData.body.war">
                                <el-radio :label="2">請選擇</el-radio>
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>

                            <span v-if="inputData.body.war==1">
                              <br><span style="color:red">欲申請專案服役者，請注意修業期限及課程學分<br/>是否符合產業實務實習、考照或就業資格條件。</span><br>
                              預定入伍時間：
                                  <el-radio-group v-model="inputData.body.lv">
                                      <el-radio :label="2">大二上</el-radio>
                                      <el-radio :label="3">大二下</el-radio><br/>
                                      <el-radio :label="4">大三上</el-radio>
                                      <el-radio :label="5">大三下</el-radio><br/>
                                      <el-radio :label="6">大四上</el-radio>
                                  </el-radio-group>
                            </span>




                          </span>
                </td>

              </tr>
             

            </table>


            <br />
            <div class="ncut-base-form-button" style="text-align: center;">
              <el-button type="primary" plain @click="prevPage()" icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
              
              <el-button type="primary" @click="nextPage()">{{$t('message.Next_txt')}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
              
              
            </div>
        </el-tab-pane>
        <el-tab-pane name="P4" key="4" :disabled="tabsData[4].disabled" >
             <table v-if ="!rwdFlag">
              <tr>
                <td style="padding: 1em;" colspan="2">
                  <b>是否擁有個人銀行或郵局帳戶</b>：
                    <el-select placeholder="請選擇是否擁有個人銀行或郵局帳戶" style="width: 8em;"
                        v-model="inputData.body.type4">
                        <el-option
                          v-for="item in setData"
                          :key="'T8'+item.id"
                          :label="item.name"
                          :value="item.id"/>
                  </el-select>
                </td>
              </tr>
           <span v-if="inputData.body.type4==0">
             <el-alert type="warning" :closable="false">暫無開立個人銀行或郵局帳戶，但已瞭解下述事項。</el-alert>
            #本校各項退費及獎(助)學金皆由轉帳方式進行撥款，請儘速至銀行或郵局開立個人金融帳戶。<br>
            #完成開戶後，請至以下路徑完成上傳作業(學校首頁/學生事務/資訊系統/學生篇/登入/學生事務/銀行資料登錄)。
           </span>
            <template v-if="inputData.body.type4==1">
                <tr>
                  <td class="ncut-edit-form-text special" style="width: 10.5em">
                    金融機構名稱
                  </td>
                  <td class="ncut-base-form-ipt" >            
                   
                          <el-input placeholder="請輸入金融機構名稱"
                          v-model="inputData.postname"></el-input>
                  </td>
                 
                </tr> 
                <tr>
                   <td class="ncut-edit-form-text special" style="width: 10.5em">
                    金融機構帳號(12-14碼)
                  </td>
                  <td class="ncut-base-form-ipt" >            
                     <el-input placeholder="請輸入金融機構帳號"
                          v-model="inputData.postno"
></el-input>
                  </td>
                </tr>

                <tr>
                  <td class="ncut-edit-form-text special" style="width: 10.5em">
                    分行名稱
                  </td>
                  <td class="ncut-base-form-ipt" >            
                          <el-input placeholder="請輸入分行名稱"
                          v-model="inputData.postsubname"></el-input>
                  </td>
                </tr> 
                <tr>
                    <td class="ncut-edit-form-text special" style="width: 10.5em;">
                    分行代碼(7碼)<br>
                                
                    </td>
                        <td class="ncut-base-form-ipt" >            
                       <el-input placeholder="請輸入分行代碼"
                          v-model="inputData.postsubid"></el-input>
                  </td>
                </tr>
                <tr>
                  <a href="https://www.fisc.com.tw/TC/Service?Caid=51254999-5d15-4ddf-8e54-4b2cdb2a8399&CaStyleId=16>" target="_blank">分行代碼查詢請按此</a>
                  <br>
                </tr>
               </template>
             </table>


             <table v-if ="rwdFlag">
              <tr>
                <td style="padding: 1em;" colspan="2">
                  <b>是否擁有個人銀行或郵局帳戶</b>：
                    <el-select placeholder="請選擇" style="width: 7em;"
                        v-model="inputData.body.type4">
                        <el-option
                          v-for="item in setData"
                          :key="'T8'+item.id"
                          :label="item.name"
                          :value="item.id"/>
                  </el-select>
                </td>
              </tr>
           <span v-if="inputData.body.type4==0">
             <el-alert type="warning" :closable="false">暫無開立個人銀行或郵局帳戶<br/>，但已瞭解下述事項。</el-alert>
            #本校各項退費及獎(助)學金皆由轉帳方式進行撥款，請儘速至銀行或郵局開立個人金融帳戶。<br>
            #完成開戶後，請至以下路徑完成上傳作業(學校首頁/學生事務/資訊系統/學生篇/登入/學生事務/銀行資料登錄)。
           </span>
            <template v-if="inputData.body.type4==1">
                <tr>
                  <td class="ncut-edit-form-text special" style="width: 10.5em">
                    金融機構名稱
                  </td>
                  <td class="ncut-base-form-ipt" >            
                   
                          <el-input placeholder="請輸入金融機構名稱"
                          v-model="inputData.postname"></el-input>
                  </td>
                 
                </tr> 
                <tr>
                   <td class="ncut-edit-form-text special" style="width: 10.5em">
                    金融機構帳號(12-14碼)
                  </td>
                  <td class="ncut-base-form-ipt" >            
                     <el-input placeholder="請輸入金融機構帳號"
                          v-model="inputData.postno"
                          style="font-size: 12px;"></el-input>
                  </td>
                </tr>

                <tr>
                  <td class="ncut-edit-form-text special" style="width: 10.5em">
                    分行名稱
                  </td>
                  <td class="ncut-base-form-ipt" >            
                          <el-input placeholder="請輸入分行名稱"
                          v-model="inputData.postsubname"></el-input>
                  </td>
                </tr> 
                <tr>
                    <td class="ncut-edit-form-text special" style="font-style: 7px;width: 10.5em">
                    分行代碼(7碼)<br>
                                <a href="https://www.fisc.com.tw/TC/Service?Caid=51254999-5d15-4ddf-8e54-4b2cdb2a8399&CaStyleId=16>" target="_blank">分行代碼查詢請按此</a>   
                  </td>
                  <td class="ncut-base-form-ipt" >            
                       <el-input placeholder="請輸入分行代碼"
                          v-model="inputData.postsubid"></el-input>
                  </td>
                </tr>
               </template>
             </table>

          
          <span slot="label"><i :class="tabsData[4].icon"></i>{{tabsData[4].title}}</span>
          <div v-if="inputData.body.type4==1">    
            <el-upload style="padding: 1em 2em 1.5em;"
                        ref="uploadV2"
                        class="upload-demo"
                        drag
                        :limit="1"
                        action="./WebApi/Tools/UploadV2"
                        accept=".jpg"
                        :name="'f' + user.id + '_1'"
                        :on-success="handleFileUploadSuccess"
                        :on-remove="handleChangeF1"
                        :before-upload="onBeforeUploadF1">
                        <i class="el-icon-plus" style="padding: 3em 0; font-size: smaller;"><span style="color:#428675;">上傳存摺封面JPG檔</span></i>
            </el-upload>
            <div style="padding: 0 0 0 2em;">
              <div style="display: block; font-size:0.9rem;">                        
                <b>上傳之檔案格式</b>：
                <ul style="list-style-type:disc; margin-bottom: 0;">
                  <li>檔名 .jpg</li>
                  <li>檔案大小不得超過4MB。</li>
                </ul>
              </div>
              <!--<p v-html="applicationMsg[1].contText" style="font-size:14px;padding: 0.25em 0.25em 0 0.25em;"
                v-if="applicationMsg!=null"></p>-->
            </div>
            <br />
            <!--<ul style="clear:both" class="response"
                  v-if="(inputData.info1!=null) && (inputData.info1.length > 0)">
                <li class="sel-file" 
                  v-for="(f,index) in inputData.info1" :key="index" :index="'0'+index" :name="'P3'+index">
                  <a href="#" @click="setUrl(f)">
                    <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                  </a>
                  &nbsp;&nbsp;
                  <el-tooltip class="item" effect="dark" content="刪除文件" placement="right-start">
                    <span v-if="f.status=='R'">
                      刪除…
                    </span>
                    <el-button icon="el-icon-delete" circle
                      @click="setDelFlag(f);"
                    v-else></el-button>
                  </el-tooltip>
                </li>
            </ul>
            <div style="border: 1px solid gray;" 
              v-show="img!=''"> 
              <el-row>
                <el-col :span="20" style="padding: 0.5rem 0.5rem 0 0.5rem;">
                  <p class="arrow">
                    頁數：<span class="turn" style="font-weight: bold;"
                            :style="{'color': pBtnColor}" 
                            @click="changePdfPage(0)"><i class="el-icon-arrow-left"></i>{{$t('message.Preview_txt')}}</span>
                            {{currPdfPage}} / {{pageCount}}
                          <span class="turn" style="font-weight: bold; color: #15231b;"
                            :style="{'color': nBtnColor}"
                            @click="changePdfPage(1)">{{$t('message.NextPage_txt')}}<i class="el-icon-arrow-right"></i></span>
                  </p>
                </el-col>
                <el-col :span="4" style="text-align: end; padding: 0.5rem 0.5rem 0 0.5rem;">
                  <el-button round icon="el-icon-close" size="mini"
                    @click="clearFile()">關閉附件</el-button>
                </el-col>
              </el-row>                              
              <pdf scale="page-width" style="width:100%;margin:20px auto;"
                ref="jpg"
                :src="img" 
                :page="currPdfPage"
                @num-pages="pageCount=$event"
                @page-loaded="currPdfPage=$event"
                @loaded="loadPdfHandler"></pdf> 
            </div>-->

            <div>

            <ul style="clear:both" v-if="(inputData.info1!=null) && (inputData.info1.length > 0)" class="response">
                                <li class="sel-file" v-for="(f,index) in filterImg1List" :key="index" :index="'0'+index" :name="'PH'+index">
                                  <a :href="'./WebApi/Tools/GetDocFile/'+f.rowId" target="_blank">
                                    <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                                    <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                                  </a>
                                  &nbsp;&nbsp;<i class="el-icon-delete"
                                                @click="setDelFlag(f)"
                                                v-show="false"
                                                ></i>
                                </li>
                              </ul>

            </div>



          </div><br/>


          <div class="ncut-base-form-button" style="text-align: center;">
            <el-button type="primary" @click="prevPage()" plain icon="el-icon-arrow-left">{{$t('message.Back_txt')}}</el-button>&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button type="success" @click="submit()">{{$t('message.Save_cmd')}}<i class="el-icon-success el-icon--right"/></el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
 <div v-else-if="inputData && inputData.admStatus ===2" class="signUp" style="padding: 0 1em; text-align: left;">
<el-alert type="warning" :closable="false"  show-icon="el-icon-arrow-left">已完成資料審查,謝謝</el-alert> 

 </div>
</template>

<script>
import pdf from 'vue-pdf'
import * as tools from '../tool';
import vOption from '@/components/common/OptionSelection.vue'
export default {
  name: 'signUp',
  data () {
    const self = this;
    return {
      windowWidth: window.innerWidth,
      curKeys: [],
      curKey: [],
      typeList: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      setData: [{id: 0, name: '否'}, {id: 1, name: '是'}],  
      saveFg: 0,
      em: '',
      active: 0,
      activeName: 'P0',
      applicationMsg: null,
      inputData: null,
      info1: null, //存摺
      info2: null, //身分證正面
      info3: null, //身分證反面
      info4: null, //退伍令
      info5: null, //免役證明
      info6: null, //服役證明
      info7: null, //宿舍申請檔案1
      info8: null, //宿舍申請檔案2
      images: [],    
      img: '',
      numPages: 2,    // 限制讀取(個資宣告)PDF檔頁數總計2 
      currPdfPage: 0, // pdf文件頁碼
      pageCount: 0,   // pdf文件總頁數
      fileIdx: 0,
      cityItem: null,
      schoolItem: null,
      districtItem1: null,
      presentType: null,
      joinType: null,
      dormTypes: [],
      serviceTypes: [],
      acceptPrivacy: 0,
      tabsData: [
        { 
          pageId: 0, 
          title: '個資蒐集告知', 
          disabled: false,  
          icon: 'el-icon-bell',
          required: true,
          validators:[
            {
              validate: (tabIdx, vm) => {
                return vm.isAcceptPrivacy();
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請於正式學期期間至各系統登錄相關資料，謝謝。</strong>',
                          
                        });
                vm.disableAllTabsButFirst(); 
              }
            }
          ]
        },  
        { 
           pageId: 1,
           title: '基本資料', 
           disabled: true, 
           icon: 'el-icon-menu'
        },  
        { 
          pageId: 2,
          title: '助學需求意願', 
          disabled: true , 
          icon: 'el-icon-document' ,
          validators:[
            {
              validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
                return vm.inputData.body.type2 !== null;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇學雜費減免需求，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
              validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
                return vm.inputData.body.type3 !== null;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇就學貸款需求，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
              validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this //dormKind
                // if type5 === null then he chooses false
                return vm.inputData.body.type5 != 1 || vm.inputData.body.dormKind;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇宿舍申請身分，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },

          ]
        },
        { 
          pageId: 3, 
          title: '兵役申請', 
          disabled: true , 
          icon: 'el-icon-edit',
          required:  vm => !vm.isFemale,
          validators: [
            {
              validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
                return vm.inputData.body.serviceStatus;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇服役類型，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            //serviceStatus = 1 or 2 / distrcit
            validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
              return vm.inputData.body.serviceStatus !== 1 && vm.inputData.body.serviceStatus !== 2
              || vm.inputData.body.schDistrict;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇縣市鄉鎮資料，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            //serviceStatus = 2 / type1
            validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
              return vm.inputData.body.serviceStatus !== 2 || vm.inputData.body.type1;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇軍階，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            //serviceStatus = 1 or 2 / info2
            validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
              return vm.inputData.body.serviceStatus !== 1 && vm.inputData.body.serviceStatus !== 2 || vm.info2 && vm.info2.length || vm.inputData.info2 && vm.inputData.info2.length;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請上傳身分證正面</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
             {
            //serviceStatus = 1 or 2 / info3
            validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
              return vm.inputData.body.serviceStatus !== 1 && vm.inputData.body.serviceStatus !== 2 || vm.info3 && vm.info3.length || vm.inputData.info3 && vm.inputData.info3.length;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請上傳身分證反面</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            // {
            //serviceStatus = 2 / info4
            //validate: (tabIdx, vm) => {
            //    // 這裡判斷 vm = this
            //  return vm.inputData.body.serviceStatus !== 2 || vm.info4 && vm.info4.length || vm.inputData.info4 && vm.inputData.info4.length;
           // },
           //   onValidFailed: (tabIdx, vm) => {
           //     vm.$message({
           //               dangerouslyUseHTMLString: true,
           //               message: '<strong style="color:red; font-size:1.2rem">請上傳退伍令，謝謝。</strong>',
            //              
            //      });
            //    vm.disableAfter(tabIdx);
            //  }
            //},
            // {
            //   //serviceStatus = 3
            // validate: (tabIdx, vm) => {
            //     // 這裡判斷 vm = this
            //   return vm.inputData.body.serviceStatus !== 3 || vm.info5 && vm.info5.length || vm.inputData.info5 && vm.inputData.info5.length;
            // },
            //   onValidFailed: (tabIdx, vm) => {
            //     vm.$message({
            //               dangerouslyUseHTMLString: true,
            //               message: '<strong style="color:red; font-size:1.2rem">請上傳免役證明，謝謝。</strong>',
                          
            //       });
            //     vm.disableAfter(tabIdx);
            //   }
            // },
          //  {
          //     //serviceStatus = 4
          //   validate: (tabIdx, vm) => {
          //       // 這裡判斷 vm = this
          //     return vm.inputData.body.serviceStatus !== 4 || vm.info6 && vm.info6.length || vm.inputData.info6 && vm.inputData.info6.length;
          //   },
          //     onValidFailed: (tabIdx, vm) => {
          //       vm.$message({
          //                 dangerouslyUseHTMLString: true,
          //                 message: '<strong style="color:red; font-size:1.2rem">請上傳服役證明，謝謝。</strong>',
                          
          //         });
          //       vm.disableAfter(tabIdx);
          //     }
          //   },
          ]
        },  
        { 
          pageId: 4,
          title: '金融機構資料', 
          disabled: true , 
          icon: 'el-icon-edit' ,
          required: true,
          validators:[
             {
              validate: (tabIdx, vm) => {
                // 這裡判斷 vm = this
                return vm.inputData.body.type4 !== null;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請選擇有無個人金融帳戶，謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
              validate: (tabIdx, vm) => {
                return !vm.inputData.body.type4 
                || vm.inputData.postname && vm.inputData.postname.trim().length
                || vm.inputData.postno && vm.inputData.postno.trim().length;
              },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請填寫金融機構名稱，謝謝。</strong>',
                          
                        });
                vm.disableAllTabsButFirst(); 
              }
            },
             {
            validate: (tabIdx, vm) => {
                return !vm.inputData.body.type4 
                || vm.inputData.postno && vm.inputData.postno.trim().length;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請填寫金融機構帳號謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            validate: (tabIdx, vm) => {
                return !vm.inputData.body.type4 
                || vm.inputData.postsubname;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請填寫分行名稱謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            validate: (tabIdx, vm) => {
                return !vm.inputData.body.type4 
                || vm.inputData.postsubid && vm.inputData.postsubid.trim().length === 7;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請填寫分行代碼(共7碼)謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            {
            validate: (tabIdx, vm) => {
                return !vm.inputData.body.type4 
                || vm.info1 && vm.info1.length
                || vm.inputData.info1 && vm.inputData.info1.length
                ;
            },
              onValidFailed: (tabIdx, vm) => {
                vm.$message({
                          dangerouslyUseHTMLString: true,
                          message: '<strong style="color:red; font-size:1.2rem">請上傳存摺封面謝謝。</strong>',
                          
                  });
                vm.disableAfter(tabIdx);
              }
            },
            
          ]
        }
      ],
    }
  },
  components: {
    pdf,
    vOption
  },
  computed: {
    rwdFlag() {
      return (this.windowWidth < 992);
    },
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    user () {
      return this.$store.state.user
    },
    sysDoc () {
      return pdf.createLoadingTask('./WebApi/Tools/ShowSystemDocByType/'.concat(this.$store.getters.getSysId).concat('/0'));
    },
    pBtnColor () {
      return (this.currPdfPage==1?'#b2bbbe': '#207f4c');
    },
    nBtnColor () {
      return (this.currPdfPage==this.pageCount?'#b2bbbe': '#c1651a');
    },

    isFemale(){
      return this.user.id && this.user.id.length > 2 && this.user.id[1] === '2';
    },
    filterImg1List: function () {
      if (null != this.inputData.info1) {
        var shoppingList = this.inputData.info1;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
        filterImg2List: function () {
      if (null != this.inputData.info2) {
        var shoppingList = this.inputData.info2;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
       filterImg3List: function () {
      if (null != this.inputData.info3) {
        var shoppingList = this.inputData.info3;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
        filterImg4List: function () {
      if (null != this.inputData.info4) {
        var shoppingList = this.inputData.info4;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
        filterImg5List: function () {
      if (null != this.inputData.info5) {
        var shoppingList = this.inputData.info5;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
      filterImg6List: function () {
      if (null != this.inputData.info6) {
        var shoppingList = this.inputData.info6;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
      filterImg7List: function () {
      if (null != this.inputData.info7) {
        var shoppingList = this.inputData.info7;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
     filterImg8List: function () {
      if (null != this.inputData.info8) {
        var shoppingList = this.inputData.info8;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
  },
  methods: {
    /* refactor */

    disableAfter(current){
      this.tabsData.filter((_, idx) => idx > current).forEach(e => e.disabled = true);
    },

    disableAllTabsButFirst(){
      this.tabsData.filter((_, idx) => idx !== 0).forEach(e => e.disabled = true);
    },
    isAcceptPrivacy(){
      return !!this.acceptPrivacy;
    },

    isNextable(tabIdx){
      if(
        typeof this.tabsData[tabIdx].required === 'boolean' && !this.tabsData[tabIdx].required
        || typeof this.tabsData[tabIdx].required === 'function' && !this.tabsData[tabIdx].required(this)
      ) {
        return true;
      } 
      if(this.tabsData[tabIdx].validators && this.tabsData[tabIdx].validators.length){
        for(let i = 0; i < this.tabsData[tabIdx].validators.length; ++i){
          if(!this.tabsData[tabIdx].validators[i].validate(tabIdx, this)){
            this.tabsData[tabIdx].validators[i].onValidFailed(tabIdx, this);
            return false;
          }
        }
      }
      return true;
    },

    activateTab(tabIdx){
      if(tabIdx >= 0){
        this.active = tabIdx;
        this.activeName = 'P' + tabIdx;
        if(tabIdx < this.tabsData.length){
          this.tabsData[tabIdx].disabled = false;
        }
      }
    },

    nextPage() {
      if(this.isNextable(this.active) && this.active < this.tabsData.length){
        this.activateTab( this.active+1 );
      }
    },

    prevPage() {
      this.activateTab(this.active - 1);
    },

    handleClick(){
      const tabIdx = parseInt(this.activeName.substring(1));
      this.activateTab(tabIdx);
    },


    filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      if (!data.disabled) {
        this.inputData.fileType = data.id;
        this.$refs.tree.setCheckedKeys([data.id]);
      }
    },
    setDelFlag(item) {
      item.status='R';
    },
    setUrl(data) {
        this.img = './WebApi/Tools/GetDocFile/'+data.rowId;
    },
    clearFile() {
      this.img = '';
    },
    changePdfPage (val) {
      if (val === 0 && this.currPdfPage > 1) {
        this.currPdfPage--;
      }
      if (val === 1 && this.currPdfPage < this.pageCount) {
        this.currPdfPage++
      }
    }, 
    loadPdfHandler (e) {
      this.currPdfPage = 1;
    },
    onBeforeUploadF1(file)
    {
      this.fileIdx = 1;
      return this.onBeforeUpload(file, 4);      
    },
    onBeforeUploadF2(file)
    {
      this.fileIdx = 2;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF3(file)
    {
      this.fileIdx = 3;
      return this.onBeforeUpload(file);      
    },
    onBeforeUploadF4(file)
    {
      this.fileIdx = 4;
      return this.onBeforeUpload(file);      
    },
     onBeforeUploadF5(file)
    {
      this.fileIdx = 5;
      return this.onBeforeUpload(file);      
    },
     onBeforeUploadF6(file)
    {
      this.fileIdx = 6
      return this.onBeforeUpload(file);      
    },
     onBeforeUploadF7(file)
    {
      this.fileIdx = 7
      return this.onBeforeUpload(file, 4);      
    },
     onBeforeUploadF8(file)
    {
      this.fileIdx = 8
      return this.onBeforeUpload(file, 4);      
    },
    onBeforeUpload(file, limitMb = 2)
    {
      this.fileData = file;
      var imgLst = ['image/jpg', 'image/jpeg'];
      var isIMAGE = true;
      
      const isUnderLimit = file.size / 1024 / 1024 < limitMb;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為)";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: msg,
                            offset: 150
                          });
      }
      if (!isUnderLimit) {
        const prettyMb = `${limitMb}MB`;
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: `<strong>檔案大小請勿超過<i style="background:yellow;">${prettyMb}</i>!</strong>`,
                            offset: 150
                          });
      }
      
      return (isIMAGE && isUnderLimit);      
    },
    handleChangeF1(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info1)) {          
        var len = this.info1.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info1[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info1.splice(idx,1);
        }
      }
    },
    handleChangeF2(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info2)) {          
        var len = this.info2.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info2[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info2.splice(idx,1);
        }
      }
    },
        handleChangeF3(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info3)) {          
        var len = this.info3.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info3[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info3.splice(idx,1);
        }
      }
    },
     handleChangeF4(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info4)) {          
        var len = this.info4.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info4[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info4.splice(idx,1);
        }
      }
    },
    handleChangeF5(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info5)) {          
        var len = this.info5.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info5[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info5.splice(idx,1);
        }
      }
    },
    handleChangeF6(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info6)) {          
        var len = this.info6.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info6[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info6.splice(idx,1);
        }
      }
    },
        handleChangeF7(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info7)) {          
        var len = this.info7.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info7[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info7.splice(idx,1);
        }
      }
    },
     handleChangeF8(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (!tools.isNull(this.info8)) {          
        var len = this.info8.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.info8[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info8.splice(idx,1);
        }
      }
    },
    handleFileUploadSuccess(res, file) {
      var nmObj = file.response[0].name.trim().split('\\');
      var objLen = nmObj.length;
      if (file.response[0].type == 'application/jpg') {
        file.response[0].ext = '.jpg';
      }
      switch(this.fileIdx) {
        case 1: // 存摺
                this.info1 = [file.response[0]];
                if (!tools.isNull(this.inputData.info1)) {
                    var len = this.inputData.info1.length;
                    for (var i = 0; i < len; i++) {                          
                      this.inputData.info1[i].status='R';
                    }
                }
                break;
         case 2: // 身分證正面 
                this.info2 = [file.response[0]];
                if (!tools.isNull(this.inputData.info2)) {
                    var len = this.inputData.info2.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info2[i].status='R';
                    }
                }
                break;
         case 3: // 身分證反面 
                this.info3 = [file.response[0]];
                if (!tools.isNull(this.inputData.info3)) {
                    var len = this.inputData.info3.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info3[i].status='R';
                    }
                }
                break;
         case 4: // 退伍令 
                this.info4 = [file.response[0]];
                if (!tools.isNull(this.inputData.info4)) {
                    var len = this.inputData.info4.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info4[i].status='R';
                    }
                }
                break;
          case 5: // 免役證明 
                this.info5 = [file.response[0]];
                if (!tools.isNull(this.inputData.info5)) {
                    var len = this.inputData.info5.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info5[i].status='R';
                    }
                }
                break;
           case 6: // 服役證明 
                this.info6 = [file.response[0]];
                if (!tools.isNull(this.inputData.info6)) {
                    var len = this.inputData.info6.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info6[i].status='R';
                    }
                }
                break;
            case 7: // 宿舍申請檔案1
                this.info7 = [file.response[0]];
                if (!tools.isNull(this.inputData.info7)) {
                    var len = this.inputData.info7.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info7[i].status='R';
                    }
                }
                break;
            case 8: // 宿舍申請檔案2
                this.info8 = [file.response[0]];
                if (!tools.isNull(this.inputData.info8)) {
                    var len = this.inputData.info8.length;
                    for (var i = 0; i < len; i++) {                          
                     this.inputData.info8[i].status='R';
                    }
                }
                break;                
      }
    },
    delDoc(type, index) {
      if (0 < index) {
        switch(type) {
          case 1:
            this.inputData.guide.splice(index,1);
            break;
          case 2:
            this.inputData.student.splice(index,1);
            break;
        }
      }
    },
    newDoc(type, flag) {
      if (null != this.inputData) {
        var tObj = {
          id       : '',
          name     : '',
          email    : '',
          phoneNo  : '',
          text1    : '',
          status   : 1
        };
        switch(type) {
          case 1:
            if (tools.isNull(this.inputData.guide)) {
              this.inputData.guide= [tObj];
            } else {
              this.inputData.guide.push(tObj);
            }
            if (flag) {              
              this.em = 'InpG'+ (this.inputData.guide.length - 1);
            }
            break;
          case 2:
            if (tools.isNull(this.inputData.student)) {
              this.inputData.student= [tObj];
            } else {
              this.inputData.student.push(tObj);
            }
            if (flag) {   
              this.em = 'InpS'+ (this.inputData.student.length - 1);
            }
            break;
        }
      }
    },
    getCityItem() {
      if (tools.isNull(this.cityItem)) { 
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/00")
            .then(function(response) {
              if (!tools.isNull(response.data)) {
                vm.cityItem = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    },
    getResDistrictItem(idx) {
      var cityName = this.inputData.body.schCity + '';

      if (tools.isNull(this.districtItem1) && !tools.isNull(cityName) && (cityName.length > 0)) {
        let vm = this
        this.$http
            .get("./WebApi/Setting/GetZipItem/"+cityName)
            .then(function(response) {
              if (!tools.isNull(response.data)) {
                vm.districtItem1 = response.data;
              }
            })
            .catch(function (error) {
              vm.$notify.error({
                                title: vm.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,網路連線失敗</strong>',
                                offset: 150
                              });
            });
      }
    }, 
    checkTab1Data() {
      var msg = '';
      return msg;
    },
    resetDisabled(idx) {  
      var len = this.tabsData.length;
      var curIdx = idx+1;
      if (len > curIdx) {        
        for (var i = curIdx; i < len; i++) {
          this.tabsData[i].disabled = true;
        }
      }
    },
    checkTab2Data() { 
      var msg = '';

      if (msg.length == 0) {
        this.tabsData[2].disabled = (this.inputData.admStatus == 0);
      } else {
        msg = '輸入'.concat(msg);
        this.resetDisabled(1);
      }

      return msg;
    },
    checkTab3Data() { 
      var msg = '';
      if (msg.length == 0) {
        this.tabsData[3].disabled =false
      } else {
        msg = '輸入'.concat(msg);
        this.resetDisabled(1);
      }

      return msg;
    },
    checkRequiredField(tabIdx) {
      var ret = false;
      var msg = '';

      switch (tabIdx) {
        case 1: // 基本資料
                //msg = this.checkTab1Data();
                break;
        case 2: // 就學貸款/學雜費減免意願調查
                //msg = this.checkTab2Data();
                break;
        case 3: // 兵役調查
                msg = this.checkTab3Data();
                break;
      }

      if (msg.length > 0) {
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,請<i style="background:yellow;">'+msg+'</i>!</strong>',
                            offset: 150
                          });
      } else {
        ret = true;
      }

      return ret;
    },    
   
    switchPage(pageId) {
      for (var i = 0; i < this.tabsData.length; i++) {
        if (i == pageId) {
          this.switchPageFunc(i);
          break;
        }
      }
    },
    setPageData(index) {
      switch (index) {
        case 0:  // 基本資料 
                this.getCityItem();
                break;
        case 1:  // 入圍複賽後需求單
                break;
        case 2:  // 作品構想書
                break;
        case 3:  // 作品構想書
                break;
        case 4:  // 作品構想書
                break;
      }
      this.switchPageFunc(index);
    },
    switchPageFunc(pageId) {
      // 畫面切換
      this.active = pageId;
      this.activeName = 'P' + pageId;
    },
    changePage(tab, event) {
      var page = parseInt(tab.index);
      if (page < this.tabsData.length) {
        //this.checkTabDataById(page);
      }
    },
    checkTabDataById(id){
      var ret = true;
      var len = this.tabsData.length;
      for (var i = 0; i < id; i++) {
        ret = this.checkRequiredField(i);

        if (!ret && (this.active != i)) {
          this.getPageUrl(i);
        }
      }
      
      if (0 == this.inputData.admStatus) {
        len = len - 1;
      }

      if (ret && (id < len)) {
        this.getPageUrl(id);
      }

      return ret;
    },  
    checkTabData(){
      var len = this.tabsData.length;
      if (0 == this.inputData.admStatus) {
        len = len - 1;
      }
      return this.checkTabDataById(len);
    },
    getPageUrl(index) {
      if (this.tabsData[index].disabled == false) {
        this.setPageData(index);
      } else {
        if (this.checkTabData()) {
          this.setPageData(index);
        }
      }
    },
    
    changeCurPage(pageId) {
      // if (!pageId || (pageId < this.active) || (this.checkRequiredField(this.active) == true)) {
      //   // 畫面切換
      //   this.getPageUrl(pageId);
      // } else {
      //   this.switchPage(this.active);
      // }
      this.switchPageFunc(pageId);
    },
    clearImage(infoLst) {
      if (null != infoLst) {
        var len1 = infoLst.length;
        for (var it = 0; it < len1; it++) {
          if (infoLst[it].status == 'A') {
            infoLst[it].rowId = '';
          }
          
          infoLst[it].dataUrl = '';
          infoLst[it].img = '';
        }
      }
    },
    removeAllImg(type) {
      //存摺
      if (1 == type) {          
        if (null != this.inputData.info1) {
          this.clearImage(this.inputData.info1);
        }      
      } else {
        this.info1 = null;
      }
      //身分證正面
      if (2 == type) {          
         if (null != this.inputData.info2) {
          this.clearImage(this.inputData.info2);
        }
     } else {        
         this.info2 = null;
      }
       //身分證反面
      if (3 == type) {          
         if (null != this.inputData.info3) {
          this.clearImage(this.inputData.info3);
        }
     } else {        
         this.info3 = null;
      }
       //退伍令
      if (4 == type) {          
         if (null != this.inputData.info4) {
          this.clearImage(this.inputData.info4);
        }
     } else {        
         this.info4 = null;
      }
      //免役證明
      if (5 == type) {          
         if (null != this.inputData.info5) {
          this.clearImage(this.inputData.info5);
        }
     } else {        
         this.info5 = null;
      }
      //服役證明
      if (6 == type) {          
         if (null != this.inputData.info6) {
          this.clearImage(this.inputData.info6);
        }
     } else {        
         this.info6 = null;
      }
    //宿舍申請檔案1
      if (7 == type) {          
         if (null != this.inputData.info7) {
          this.clearImage(this.inputData.info7);
        }
     } else {        
         this.info7 = null;
      }
    //宿舍申請檔案2
      if (8 == type) {          
         if (null != this.inputData.info8) {
          this.clearImage(this.inputData.info8);
        }
     } else {        
         this.info8 = null;
      }
    },
    setPhoto() {
      // 存摺
      if (null != this.info1) {
        var len = this.info1.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info1[it].status) {
            if (null == this.inputData.info1) {
              this.inputData.info1 = [this.info1[it]];
            } else {
              this.inputData.info1.push(this.info1[it]);
            }
          }
        }
      }
      //身分證正面
      if (null != this.info2) {
        var len = this.info2.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info2[it].status) {
            if (null == this.inputData.info2) {
              this.inputData.info2 = [this.info2[it]];
            } else {
              this.inputData.info2.push(this.info2[it]);
            }
          }
        }
      }
       //身分證反面
      if (null != this.info3) {
        var len = this.info3.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info3[it].status) {
            if (null == this.inputData.info3) {
              this.inputData.info3 = [this.info3[it]];
            } else {
              this.inputData.info3.push(this.info3[it]);
            }
          }
        }
      }
      //退伍令
      if (null != this.info4) {
        var len = this.info4.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info4[it].status) {
            if (null == this.inputData.info4) {
              this.inputData.info4 = [this.info4[it]];
            } else {
              this.inputData.info4.push(this.info4[it]);
            }
          }
        }
      }
        //免役證明
      if (null != this.info5) {
        var len = this.info5.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info5[it].status) {
            if (null == this.inputData.info5) {
              this.inputData.info5 = [this.info5[it]];
            } else {
              this.inputData.info5.push(this.info5[it]);
            }
          }
        }
      }
        //服役證明
      if (null != this.info6) {
        var len = this.info6.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info6[it].status) {
            if (null == this.inputData.info6) {
              this.inputData.info6 = [this.info6[it]];
            } else {
              this.inputData.info6.push(this.info6[it]);
            }
          }
        }
      }
      
      //宿舍申請檔案1
      if (null != this.info7) {
        var len = this.info7.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info7[it].status) {
            if (null == this.inputData.info7) {
              this.inputData.info7 = [this.info7[it]];
            } else {
              this.inputData.info7.push(this.info7[it]);
            }
          }
        }
      }

      //宿舍申請檔案2
      if (null != this.info8) {
        var len = this.info8.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info8[it].status) {
            if (null == this.inputData.info8) {
              this.inputData.info8 = [this.info8[it]];
            } else {
              this.inputData.info8.push(this.info8[it]);
            }
          }
        }
      }


      this.removeAllImg(1);
      this.removeAllImg(2);
      this.removeAllImg(3);
      this.removeAllImg(4);
      this.removeAllImg(5);
      this.removeAllImg(6);
      this.removeAllImg(7);
      this.removeAllImg(8);
    },
    submit () {
      if (this.isNextable(this.active)) {
        var vm = this;
        this.inputData.updateUser = vm.user.id; 
        if(this.inputData.body.war ==0 ||this.inputData.body.war ==2 )
        {
       this.inputData.body.lv =0

        }
        this.setPhoto();                 
        this.$http.put('./WebApi/Apply/SetFormData',this.inputData)
                  .then((success) =>{                            
                                      if (!tools.isNull(success.data)) {
                                        switch(success.data.key) {
                                          case 0:
                                                  vm.$message({
                                                      message: '恭喜您,存檔成功',
                                                      type: 'success'
                                                    });
                                                  vm.saveFg = 2;
                                                  break;
                                          case 1:
                                          default:
                                                  vm.$notify.error({
                                                                    title: vm.$t('message.Error_txt'),
                                                                    dangerouslyUseHTMLString: true,
                                                                    message: '<strong>對不起,' + success.data.text+'</strong>',
                                                                    offset: 150
                                                                  });
                                                  break;
                                        }
                                      }
                  })
                  .catch(function (error) {
                    vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                        offset: 150
                                    });
                  });
      }
    },
    getApplicationMsg() {
        return this.$http
                   .get('./WebApi/Apply/GetFormMsg/'.concat(this.sysId));
    },
    getFormInfo() {
      if (0 < this.user.dId) {      
        return this.$http
                   .get('./WebApi/Apply/GetFormDataById/'.concat(this.setting.enrollID[0].codeName).concat("/").concat(this.user.dId));  

      } else {      
        return this.$http
                   .get('./WebApi/Apply/GetFormData/'.concat(this.setting.enrollID[0].codeName).concat("/").concat(this.user.id));  
      }
    },
    getTypeTree() {
      return this.$http.get('./WebApi/Apply/GetTypeTree/' + this.sysId);
    },
    getTypeSet: function (name) {
      return this.$http
                 .get('./WebApi/Tools/GetCodeListToInt/'.concat(this.sysId).concat('/').concat(name));
    },

    onPrivacyChange(v){
       if(v === 0){
         this.tabsData[1].disabled = true;
         this.tabsData[2].disabled = true;
         this.tabsData[3].disabled = true;
         this.tabsData[4].disabled = true;
       }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth =  window.innerWidth;
    }
  },
  created () {
    console.log('====== SignUpView =====')
    var vm = this;
    this.$http.all([this.getApplicationMsg(), this.getFormInfo(), this.getTypeTree(), this.getTypeSet('PresentType'), this.getTypeSet('JoinType'), this.getTypeSet('ServiceType'), this.getTypeSet('DormType')])
        .then(vm.$http.spread(function ( data0, data1, data2, data3, data4, data5,data6) {
          vm.applicationMsg = data0.data;
          if (!tools.isNull(data1.data)) {
            vm.inputData = data1.data;
            // first time
            if(!vm.inputData.admStatus)
            {
                vm.inputData.body.type2 = vm.inputData.body.type3 = vm.inputData.body.type4 = null;
                console.log(vm.inputData.body.type4);
            }
            
            //vm.info1 = vm.inputData.info1 || [];
            //vm.info2 = vm.inputData.info2 || [];
            //vm.info3 = vm.inputData.info3 || [];
            //vm.info4 = vm.inputData.info4 || [];
            //vm.info5 = vm.inputData.info5 || [];
            //vm.info6 = vm.inputData.info6 || [];
            if (0 < vm.inputData.fileType) {
              vm.curKey.push(vm.inputData.fileType); 
            }
            if (tools.isNull(vm.inputData.guide) || (0 == vm.inputData.guide.length)) {
              vm.newDoc(1, false);
            } 
            if (tools.isNull(vm.inputData.student) || (0 == vm.inputData.student.length)) {                
              vm.newDoc(2, false);
            } 
            if (vm.inputData.admStatus!=0) {
              vm.tabsData[1].disabled = false;
              vm.tabsData[2].disabled = false;
              vm.tabsData[3].disabled = false;
              vm.tabsData[4].disabled = false;
            }
          }
          if (!tools.isNull(data2.data)) {
            var tFlag = false;
            vm.typeList = data2.data;
            var tLen = vm.typeList[0].children.length;
            for (var i = 0; i < tLen && !tFlag; i++) {
              var cLen = vm.typeList[0].children[i].children.length;
              for (var j = 0; j < cLen && !tFlag; j++) {
                if (vm.typeList[0].children[i].children[j].id == vm.inputData.fileType) {                  
                  vm.curKeys.push(vm.typeList[0].children[i].id);                 
                  vm.curKeys.push(vm.typeList[0].children[i].children[j].id);
                  tFlag = true;
                }
              }
            }
          }
          if (!tools.isNull(data3.data)) {
            vm.presentType = data3.data;
          }
          if (!tools.isNull(data4.data)) {
            vm.joinType = data4.data;
          }
          if (!tools.isNull(data5.data)) {
            vm.serviceTypes = data5.data;
          }
           if (!tools.isNull(data6.data)) {
            vm.dormTypes = data6.data;
          }
          if (0 < vm.inputData.body.schCity) {
            vm.getResDistrictItem(); 
          }
          vm.setPageData(0);
        }))
  },
  updated() {
    if (!tools.isNullOrWhiteSpace(this.em)) {
      this.$refs[this.em][0].focus();
      this.em = '';
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.div-memo {
  text-align: left;
  margin: 1em 1em;
  font-size: large;
  border: solid 1px #e6e6e6;
  padding: 1em;
  color: #485b4d;
}
.modal-show {
  transition: transform 0.3s ease-out 0s;  
  transform: translate(0px, 0px);
  z-index: 1050;
  display: block;
  opacity: 1;
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SignUpView.vue